import { render, staticRenderFns } from "./ResidentMonitoredHealthModal.vue?vue&type=template&id=cbb8d2c8&scoped=true&"
import script from "./ResidentMonitoredHealthModal.vue?vue&type=script&lang=js&"
export * from "./ResidentMonitoredHealthModal.vue?vue&type=script&lang=js&"
import style0 from "./ResidentMonitoredHealthModal.vue?vue&type=style&index=0&id=cbb8d2c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb8d2c8",
  null
  
)

export default component.exports